import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=11c237fe&"
import script from "./NewTemplate.vue?vue&type=script&lang=js&"
export * from "./NewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewTemplate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports